const defaultSearchParams = {
  supplierName: null,
  year: null,
  seasonId: null,
  orderDateFrom: "",
  orderDateTo: "",
  scheduledDeliveryDateFrom: "",
  scheduledDeliveryDateTo: "",
  deliveryDateFrom: "",
  deliveryDateTo: "",
  page: 0,
  size: 10,
  sort: "asc", // 'desc'
}

const dateMaps = {
  orderDate: ["orderDateFrom", "orderDateTo"],
  scheduledDeliveryDate: [
    "scheduledDeliveryDateFrom",
    "scheduledDeliveryDateTo",
  ],
  deliveryDate: ["deliveryDateFrom", "deliveryDateTo"],
}

const defaultCSVParams = {
  supplierName: null,
  storeName: null,
  customerName: null,
  type: "Bespoke", // MTM || BeSpoke
  productId: "",
  orderDateFrom: "",
  orderDateTo: "",
  scheduledDeliveryDateFrom: "",
  scheduledDeliveryDateTo: "",
  deliveryDateFrom: "",
  deliveryDateTo: "",
}

const defaultSelect = { label: "", value: "" }

const defaultCreatePayload = {
  supplierId: 0,
  picId: 0,
  picName: "",
  orderDate: new Date().toISOString().slice(0, 10),
  year: 0,
  seasonId: 0,
  productId: 0,
  productName: "",
  fabricCompanyId: 0,
  fabricId: 0,
  fabricYear: 0,
  fabricSeasonId: 0,
  unitPrice: 0,
  scale: 0,
  color: "",
  outerMaterialComposition: "",
  newProduct: false,
  sample: true,
  scheduledDeliveryDate: "",
  type: "ファクトリーメイド",
  model: "",
  pleats1: "",
  pleats2: "",
  front: "",
  sidePocket: "",
  pissPocket1: "",
  pissPocket2: "",
  flap: "",
  takeOutYourBelt: "",
  coinPocket: "",
  outerSideStitch: "",
  beltLoop: "",
  adjuster: "",
  beltWidth: "",
  hemSpecification: "",
  backOfTheKnee: "",
  suspenderButton: "",
  sizes: [
    {
      size: "42",
      orderQty: "",
      unitPrice: "",
    },
    {
      size: "44",
      orderQty: "",
      unitPrice: "",
    },
    {
      size: "46",
      orderQty: "",
      unitPrice: "",
    },
    {
      size: "48",
      orderQty: "",
      unitPrice: "",
    },
    {
      size: "50",
      orderQty: "",
      unitPrice: "",
    },
    {
      size: "52",
      orderQty: "",
      unitPrice: "",
    },
    {
      size: "54",
      orderQty: "",
      unitPrice: "",
    },
  ],
}

const designNDetailPath = {
  model: "model",
  pleats1: "pleats-1",
  pleats2: "pleats-2",
  front: "front",
  sidePocket: "side-pocket",
  pissPocket1: "piss-pocket-1",
  pissPocket2: "piss-pocket-2",
  flap: "flap",
  takeOutYourBelt: "take-out-your-belt",
  outerSideStitch: "outer-side-stitch",
  beltLoop: "belt-loop",
  adjuster: "adjuster",
  beltWidth: "belt-width",
  hemSpecification: "hem-specification",
  backOfTheKnee: "back-of-the-knee",
  suspenderButton: "suspender-button",
}

const orderDetailSize = {
  defect: null,
  orderQty: 0,
  size: "",
  unitPrice: 0,
}

const defaultOrderDetails = {
  アトリエメイド: {
    sizes: Array(7)
      .fill(orderDetailSize)
      .map((item, idx) => ({
        ...item,
        size: `${(idx + 1) * 2 + 40}`,
      })),
    reducedProduction: Array(7).fill(0),
    completedInspection: Array(7).fill(0),
    numberOfRemaining: Array(7).fill(0),
  },
  ファクトリーメイド: {
    sizes: Array(7)
      .fill(orderDetailSize)
      .map((item, idx) => ({
        ...item,
        size: `${(idx + 1) * 2 + 40}`,
      })),
    numberOfDeliveries: Array(7).fill(0),
    reducedProduction: Array(7).fill(0),
    completedInspection: Array(7).fill(0),
    incompleteDeliveries: Array(7).fill(0),
  },
}

const defaultEditPayload = {
  sizes: [
    {
      size: "42",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
    {
      size: "44",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
    {
      size: "46",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
    {
      size: "48",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
    {
      size: "50",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
    {
      size: "52",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
    {
      size: "54",
      reducedProduction: 0,
      completedInspection: 0,
      orderQty: 0,
      unitPrice: 0,
    },
  ],
}

// const breadcrumbTitle = [];
const tabStates = [
  {
    tab: "受注詳細",
    title: "RTW法人受注",
  },
  {
    tab: "手書きノート",
    title: "RTW HandWiting",
  },
  {
    tab: "検品",
    title: "RTW編集　ー　検品情報",
  },
]

const yearsOption = [
  {
    value: "22",
    label: "2022",
  },
  {
    value: "23",
    label: "2023",
  },
  {
    value: "24",
    label: "2024",
  },
  {
    value: "25",
    label: "2025",
  },
  {
    value: "26",
    label: "2026",
  },
  {
    value: "27",
    label: "2027",
  },
  {
    value: "28",
    label: "2028",
  },
  {
    value: "29",
    label: "2029",
  },
  {
    value: "30",
    label: "2030",
  },
]

export {
  defaultSearchParams,
  defaultSelect,
  defaultCreatePayload,
  defaultOrderDetails,
  defaultCSVParams,
  defaultEditPayload,
  tabStates,
  dateMaps,
  yearsOption,
}
